module.exports = __webpack_public_path__ + "static/img/keurig-logo.9266332.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clientlogos/keurig-logo.jpg
// module id = Wlwf
// module chunks = 1